import React from "react";
import { Container } from "react-bootstrap";

import Particle from "../components/Particle";
import Techstack from "../components/Skillset/Techstack";
import Toolstack from "../components/Skillset/Toolstack";
import Github from "../components/Skillset/Github";
import Chatbot from "../components/Chatbot";
import PageTransition from "../components/PageTransition";
import AnimatedSection from "../components/AnimatedSection";

const Skillset = () => {
  return (
    <PageTransition>
      <Container fluid className="about-section">
        <Particle />
        <Container>
          <AnimatedSection direction="up" delay={0}>
            <h1 className="project-heading">
              Professional <strong className="yellow">Skillset</strong>
            </h1>
            <div className="section-divider"></div>
          </AnimatedSection>

          <Techstack />

          <AnimatedSection direction="up" delay={0}>
            <h1 className="project-heading" style={{ marginTop: "40px" }}>
              <strong className="yellow">Tools</strong> I use
            </h1>
            <div className="section-divider"></div>
          </AnimatedSection>

          <Toolstack />

          <Github />
        </Container>
        <Chatbot />
      </Container>
    </PageTransition>
  );
};

export default Skillset;
